import { FallbackProps } from 'react-error-boundary';
import { Link } from 'react-router';

export const ErrorHandler = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  return (
    <div className="error-page flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-red- mb-4 text-5xl font-semibold">Errors</h1>
        <p className="text-grey-800 text-2xl font-semibold">{error.message}</p>
        <button className="mt-4" onClick={resetErrorBoundary}>
          Please <span className="font-bold">reload page</span> or click{' '}
          <Link to="/" className="font-bold">
            here
          </Link>{' '}
          to go back to the home page.
        </button>
      </div>
    </div>
  );
};
